import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'FALSE',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Returns the value FALSE.',
  description:
    'Returns the value FALSE. This is equivalent to the FALSE literal and is included only to provide compatibility with other spreadsheet programs.',
  params: [],
  eval: (): false => false,
} satisfies EvaluablePrimitiveSpreadsheetFunction;
